import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_PLACE_BY_ID } from "../../../../operations/queries/operations/queries/get-place-by-id.js";
import fromPlaceByIdQueryToPlaceById from "../../adapters/hooks/api/adapters/fromPlaceByIdQueryToPlaceById.js";
const usePlaceById = (variables) => {
  const [query, queryState] = useLazyQuery(GET_PLACE_BY_ID, {
    variables,
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    onError(error) {
      toast.failed("stores.page.search.getPlaceById.error");
      console.error("Failed to fetch place by id: ", error);
    }
  });
  return React.useMemo(
    () => [
      query,
      {
        ...queryState,
        data: fromPlaceByIdQueryToPlaceById(queryState.data?.placeById)
      }
    ],
    [query, queryState]
  );
};
export {
  usePlaceById as default
};
//# sourceMappingURL=use-place-by-id.js.map
